// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"_3njHy","no_photo":"_26gZT"};